import { ReactComponent as LostNavigation } from '@inspectify/design/assets/images/general/LostNavigation.svg';
import { Container, Stack, Typography } from '@mui/material';
import React from 'react';
import AppFooter from '../layouts/AppFooter';
import { DefaultAppBar } from '../layouts/Header/DefaultAppBar';
import { State } from './ErrorBoundary';

const ReportErrorBoundary = ({ error }: State) => (
  <>
    <DefaultAppBar />
    <Container>
      <Stack spacing={2} alignItems="center" py={4}>
        <LostNavigation />
        <Stack spacing={2} alignItems="center">
          <Typography variant="h1">Please refresh the page and try again.</Typography>
          <Typography variant="h3" mt={2}>If the issue persists, please contact support.</Typography>
          <Typography variant="body1">{error?.message}</Typography>
        </Stack>
      </Stack>
    </Container>
    <AppFooter />
  </>
);

export default ReportErrorBoundary;
